/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import * as com_amazon_coral_availability from "@amzn/coral_com-amazon-coral-availability";
import * as com_amazon_coral_service_bsf from "@amzn/coral_com-amazon-coral-service-bsf";
import * as com_amazon_coral_client from "@amzn/coral_com-amazon-coral-client";
import * as com_amazon_coral_service from "@amzn/coral_com-amazon-coral-service";
import { GetFeedbacksResponse } from "./GetFeedbacksResponse";
import { GetDisplayableFeedbackQuestionnaireRequest } from "./GetDisplayableFeedbackQuestionnaireRequest";
import { GetFeedbackQuestionnaireRequest } from "./GetFeedbackQuestionnaireRequest";
import { UpsertFeedbackQuestionnaireRequest } from "./UpsertFeedbackQuestionnaireRequest";
import { GetDisplayableFeedbackQuestionnaireResponse } from "./GetDisplayableFeedbackQuestionnaireResponse";
import { TCFAInvalidRequestException } from "./TCFAInvalidRequestException";
import { TCFANonRecoverableException } from "./TCFANonRecoverableException";
import { TCFARecoverableException } from "./TCFARecoverableException";
import { GetFeedbacksRequest } from "./GetFeedbacksRequest";
import { SubmitFeedbackRequest } from "./SubmitFeedbackRequest";
import { GetFeedbackQuestionnaireResponse } from "./GetFeedbackQuestionnaireResponse";
import * as com_amazon_coral_service_jms from "@amzn/coral_com-amazon-coral-service-jms";
import * as com_amazon_coral_validate from "@amzn/coral_com-amazon-coral-validate";
import * as com_amazon_coral_service_http from "@amzn/coral_com-amazon-coral-service-http";
import { CoralClient, CoralResponse, } from "@amzn/ihm-js-coral-client";
import { CoralClientHttpBindingInterceptor, CoralClientSerdesInterceptor, InterceptingHandler, } from "@amzn/ihm-js-coral-client";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
export const transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor = new CoralClientSerdesInterceptor({
    GetDisplayableFeedbackQuestionnaire: {
        deserializationFn: GetDisplayableFeedbackQuestionnaireResponse.fromJson,
        serializationFn: GetDisplayableFeedbackQuestionnaireRequest.toJson,
        modelledExceptions: [
            TCFAInvalidRequestException,
            TCFARecoverableException,
            TCFANonRecoverableException,
        ],
    },
    GetFeedbackQuestionnaire: {
        deserializationFn: GetFeedbackQuestionnaireResponse.fromJson,
        serializationFn: GetFeedbackQuestionnaireRequest.toJson,
        modelledExceptions: [
            TCFAInvalidRequestException,
            TCFARecoverableException,
            TCFANonRecoverableException,
        ],
    },
    GetFeedbacks: {
        deserializationFn: GetFeedbacksResponse.fromJson,
        serializationFn: GetFeedbacksRequest.toJson,
        modelledExceptions: [
            TCFAInvalidRequestException,
            TCFARecoverableException,
            TCFANonRecoverableException,
        ],
    },
    SubmitFeedback: {
        serializationFn: SubmitFeedbackRequest.toJson,
        modelledExceptions: [
            TCFAInvalidRequestException,
            TCFARecoverableException,
            TCFANonRecoverableException,
        ],
    },
    UpsertFeedbackQuestionnaire: {
        serializationFn: UpsertFeedbackQuestionnaireRequest.toJson,
        modelledExceptions: [
            TCFAInvalidRequestException,
            TCFARecoverableException,
            TCFANonRecoverableException,
        ],
    },
}, [
    com_amazon_coral_availability.BackOffException,
    com_amazon_coral_availability.ThrottlingException,
    com_amazon_coral_client.ClientUnavailableException,
    com_amazon_coral_client.HttpConnectionTimeoutException,
    com_amazon_coral_client.HttpFailureException,
    com_amazon_coral_client.HttpTimeoutException,
    com_amazon_coral_service_bsf.InvalidCodigoMessageException,
    com_amazon_coral_service_http.HeaderMisclassificationException,
    com_amazon_coral_service_http.HttpNotFoundException,
    com_amazon_coral_service_http.InvalidAuthSchemeException,
    com_amazon_coral_service_http.InvalidAuthSchemeParameterException,
    com_amazon_coral_service_http.InvalidMessageDigestException,
    com_amazon_coral_service_http.MissingAuthSchemeParameterException,
    com_amazon_coral_service_http.MissingMessageDigestException,
    com_amazon_coral_service_http.MissingRequiredHeaderException,
    com_amazon_coral_service_jms.MessageProcessingException,
    com_amazon_coral_service_jms.MessagePublishException,
    com_amazon_coral_service.AccessDeniedException,
    com_amazon_coral_service.DelegationException,
    com_amazon_coral_service.ExpiredTokenException,
    com_amazon_coral_service.IncompleteSignatureException,
    com_amazon_coral_service.InternalFailure,
    com_amazon_coral_service.InvalidAwsQueryStringException,
    com_amazon_coral_service.InvalidParameterCombinationException,
    com_amazon_coral_service.InvalidParameterValueException,
    com_amazon_coral_service.InvalidQueryParameterException,
    com_amazon_coral_service.InvalidQueryStringException,
    com_amazon_coral_service.InvalidSignatureException,
    com_amazon_coral_service.MalformedHttpRequestException,
    com_amazon_coral_service.MissingActionException,
    com_amazon_coral_service.MissingAuthenticationTokenException,
    com_amazon_coral_service.MissingRequiredParameterException,
    com_amazon_coral_service.NotAuthorizedException,
    com_amazon_coral_service.RequestAbortedException,
    com_amazon_coral_service.RequestEntityTooLargeException,
    com_amazon_coral_service.RequestExpiredException,
    com_amazon_coral_service.RequestTimeoutException,
    com_amazon_coral_service.SerializationException,
    com_amazon_coral_service.ServiceUnavailableException,
    com_amazon_coral_service.SubscriptionRequiredException,
    com_amazon_coral_service.TimeoutException,
    com_amazon_coral_service.TransmutationException,
    com_amazon_coral_service.UnknownOperationException,
    com_amazon_coral_service.UnrecognizedClientException,
    com_amazon_coral_service.UnsupportedMediaTypeException,
    com_amazon_coral_validate.ValidationException,
]);
export const transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor = new CoralClientHttpBindingInterceptor({
    GetDisplayableFeedbackQuestionnaire: {
        method: "GET",
        path: "/displayable-questionnaire/v1/applications/{applicationId}/intents/{feedbackIntent}/",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
    GetFeedbackQuestionnaire: {
        method: "GET",
        path: "/questionnaires/v1/applications/{applicationId}/intents/{feedbackIntent}",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
    GetFeedbacks: {
        method: "GET",
        path: "/feedbacks/v1/applications/{applicationId}?endDate={endDate}&feedbackIntent={feedbackIntent}&pageSize={pageSize}&pageToken={pageToken}&startDate={startDate}",
        labelTransformations: {
            pageSize: "pageSize",
            pageToken: "pageToken",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
    SubmitFeedback: {
        method: "POST",
        path: "/feedbacks/v1/applications/{applicationId}/intents/{feedbackIntent}?sif_profile={sifProfileId}",
        labelTransformations: {
            sifProfileId: "sifProfileId",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
    UpsertFeedbackQuestionnaire: {
        method: "POST",
        path: "/questionnaires/v1/applications/{applicationId}/intents/{feedbackIntent}",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
});
/**
 * <p>This service will implement a generic feedback module, which will allow users to provide their feedback.<\/p>
 **/
export class TransCustomerFeedbackAggreatorServiceLambda extends CoralClient {
    constructor(config, handler) {
        const serdesHandler = new InterceptingHandler(handler, [
            transCustomerFeedbackAggreatorServiceLambdaSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    /**
     * <p>getDisplayableFeedbackQuestionnaire will be used to get eligible questionnaire from DDB Table<\/p>
     **/
    getDisplayableFeedbackQuestionnaire(request) {
        return super.call("GetDisplayableFeedbackQuestionnaire", request).pipe(map(({ body }) => {
            if (!(body instanceof GetDisplayableFeedbackQuestionnaireResponse)) {
                throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetDisplayableFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>Get Feedback Questionnaire based on applicationId and feedbackIntent. Each service using feedback module
     * will have a separate applicationID which will be a primary key to differentiate between questionnaire of
     * different service. Questionnaire can be further divided on the basis of feedbackIntent which represents the
     * type of feedback appears to user. It can be a general feedback which users can access through a link or button,
     * or it can be a triggered feedback which will be triggered based on some events in the service.<\/p>
     **/
    getFeedbackQuestionnaire(request) {
        return super.call("GetFeedbackQuestionnaire", request).pipe(map(({ body }) => {
            if (!(body instanceof GetFeedbackQuestionnaireResponse)) {
                throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>This operation will fetch the users feedback submitted for an application between the provided start and end date.<\/p>
     **/
    getFeedbacks(request) {
        return super.call("GetFeedbacks", request).pipe(map(({ body }) => {
            if (!(body instanceof GetFeedbacksResponse)) {
                throw new TypeError(`[TransCustomerFeedbackAggreatorServiceLambda] Expected response body to be of type GetFeedbacksResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>This operation will store the user feedback based on applicationId and feedbackIntent<\/p>
     **/
    submitFeedback(request) {
        return super.call("SubmitFeedback", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>UpsertFeedbackQuestionnaire will be used to update or add new questionnaire in DDB Table<\/p>
     **/
    upsertFeedbackQuestionnaire(request) {
        return super.call("UpsertFeedbackQuestionnaire", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
TransCustomerFeedbackAggreatorServiceLambda.assembly = "com.amazon.trans.feedback.tcfa.model.v1";
TransCustomerFeedbackAggreatorServiceLambda.serviceName = "TransCustomerFeedbackAggreatorServiceLambda";
